var cov_1z7nhipb2h = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Table/fixedAuto.tsx",
      hash = "c59a221c45b18380c719ddd3a71e4af9f495e7d1",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Table/fixedAuto.tsx",
    statementMap: {
      "0": {
        start: {
          line: 15,
          column: 2
        },
        end: {
          line: 90,
          column: 3
        }
      },
      "1": {
        start: {
          line: 24,
          column: 6
        },
        end: {
          line: 24,
          column: 18
        }
      },
      "2": {
        start: {
          line: 25,
          column: 6
        },
        end: {
          line: 27,
          column: 7
        }
      },
      "3": {
        start: {
          line: 28,
          column: 6
        },
        end: {
          line: 28,
          column: 52
        }
      },
      "4": {
        start: {
          line: 29,
          column: 6
        },
        end: {
          line: 29,
          column: 68
        }
      },
      "5": {
        start: {
          line: 34,
          column: 19
        },
        end: {
          line: 36,
          column: 7
        }
      },
      "6": {
        start: {
          line: 35,
          column: 13
        },
        end: {
          line: 35,
          column: 96
        }
      },
      "7": {
        start: {
          line: 37,
          column: 20
        },
        end: {
          line: 37,
          column: 82
        }
      },
      "8": {
        start: {
          line: 38,
          column: 6
        },
        end: {
          line: 43,
          column: 7
        }
      },
      "9": {
        start: {
          line: 40,
          column: 8
        },
        end: {
          line: 42,
          column: 10
        }
      },
      "10": {
        start: {
          line: 47,
          column: 6
        },
        end: {
          line: 47,
          column: 60
        }
      },
      "11": {
        start: {
          line: 47,
          column: 37
        },
        end: {
          line: 47,
          column: 60
        }
      },
      "12": {
        start: {
          line: 48,
          column: 6
        },
        end: {
          line: 48,
          column: 52
        }
      },
      "13": {
        start: {
          line: 48,
          column: 39
        },
        end: {
          line: 48,
          column: 52
        }
      },
      "14": {
        start: {
          line: 49,
          column: 6
        },
        end: {
          line: 49,
          column: 29
        }
      },
      "15": {
        start: {
          line: 53,
          column: 6
        },
        end: {
          line: 53,
          column: 28
        }
      },
      "16": {
        start: {
          line: 57,
          column: 6
        },
        end: {
          line: 57,
          column: 31
        }
      },
      "17": {
        start: {
          line: 57,
          column: 25
        },
        end: {
          line: 57,
          column: 31
        }
      },
      "18": {
        start: {
          line: 58,
          column: 29
        },
        end: {
          line: 58,
          column: 102
        }
      },
      "19": {
        start: {
          line: 59,
          column: 31
        },
        end: {
          line: 59,
          column: 104
        }
      },
      "20": {
        start: {
          line: 60,
          column: 6
        },
        end: {
          line: 60,
          column: 52
        }
      },
      "21": {
        start: {
          line: 60,
          column: 46
        },
        end: {
          line: 60,
          column: 52
        }
      },
      "22": {
        start: {
          line: 62,
          column: 6
        },
        end: {
          line: 63,
          column: 42
        }
      },
      "23": {
        start: {
          line: 62,
          column: 28
        },
        end: {
          line: 62,
          column: 39
        }
      },
      "24": {
        start: {
          line: 63,
          column: 11
        },
        end: {
          line: 63,
          column: 42
        }
      },
      "25": {
        start: {
          line: 63,
          column: 31
        },
        end: {
          line: 63,
          column: 42
        }
      },
      "26": {
        start: {
          line: 64,
          column: 6
        },
        end: {
          line: 66,
          column: 8
        }
      },
      "27": {
        start: {
          line: 70,
          column: 6
        },
        end: {
          line: 70,
          column: 74
        }
      },
      "28": {
        start: {
          line: 70,
          column: 68
        },
        end: {
          line: 70,
          column: 74
        }
      },
      "29": {
        start: {
          line: 71,
          column: 6
        },
        end: {
          line: 71,
          column: 23
        }
      },
      "30": {
        start: {
          line: 75,
          column: 6
        },
        end: {
          line: 75,
          column: 36
        }
      },
      "31": {
        start: {
          line: 79,
          column: 20
        },
        end: {
          line: 79,
          column: 35
        }
      },
      "32": {
        start: {
          line: 80,
          column: 6
        },
        end: {
          line: 80,
          column: 43
        }
      },
      "33": {
        start: {
          line: 81,
          column: 6
        },
        end: {
          line: 88,
          column: 7
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 14,
            column: 16
          },
          end: {
            line: 14,
            column: 17
          }
        },
        loc: {
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 90,
            column: 3
          }
        },
        line: 15
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 23,
            column: 5
          }
        },
        loc: {
          start: {
            line: 23,
            column: 47
          },
          end: {
            line: 30,
            column: 5
          }
        },
        line: 23
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 32,
            column: 5
          }
        },
        loc: {
          start: {
            line: 32,
            column: 58
          },
          end: {
            line: 44,
            column: 5
          }
        },
        line: 32
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 35,
            column: 8
          },
          end: {
            line: 35,
            column: 9
          }
        },
        loc: {
          start: {
            line: 35,
            column: 13
          },
          end: {
            line: 35,
            column: 96
          }
        },
        line: 35
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 46,
            column: 4
          },
          end: {
            line: 46,
            column: 5
          }
        },
        loc: {
          start: {
            line: 46,
            column: 15
          },
          end: {
            line: 50,
            column: 5
          }
        },
        line: 46
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        },
        loc: {
          start: {
            line: 52,
            column: 41
          },
          end: {
            line: 54,
            column: 5
          }
        },
        line: 52
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 56,
            column: 5
          }
        },
        loc: {
          start: {
            line: 56,
            column: 17
          },
          end: {
            line: 67,
            column: 5
          }
        },
        line: 56
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 69,
            column: 5
          }
        },
        loc: {
          start: {
            line: 69,
            column: 16
          },
          end: {
            line: 72,
            column: 5
          }
        },
        line: 69
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 74,
            column: 5
          }
        },
        loc: {
          start: {
            line: 74,
            column: 26
          },
          end: {
            line: 76,
            column: 5
          }
        },
        line: 74
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 78,
            column: 4
          },
          end: {
            line: 78,
            column: 5
          }
        },
        loc: {
          start: {
            line: 78,
            column: 13
          },
          end: {
            line: 89,
            column: 5
          }
        },
        line: 78
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 35,
            column: 13
          },
          end: {
            line: 35,
            column: 96
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 35,
            column: 13
          },
          end: {
            line: 35,
            column: 38
          }
        }, {
          start: {
            line: 35,
            column: 42
          },
          end: {
            line: 35,
            column: 96
          }
        }],
        line: 35
      },
      "1": {
        loc: {
          start: {
            line: 37,
            column: 20
          },
          end: {
            line: 37,
            column: 82
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 37,
            column: 20
          },
          end: {
            line: 37,
            column: 74
          }
        }, {
          start: {
            line: 37,
            column: 78
          },
          end: {
            line: 37,
            column: 82
          }
        }],
        line: 37
      },
      "2": {
        loc: {
          start: {
            line: 38,
            column: 6
          },
          end: {
            line: 43,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 38,
            column: 6
          },
          end: {
            line: 43,
            column: 7
          }
        }, {
          start: {
            line: 38,
            column: 6
          },
          end: {
            line: 43,
            column: 7
          }
        }],
        line: 38
      },
      "3": {
        loc: {
          start: {
            line: 47,
            column: 6
          },
          end: {
            line: 47,
            column: 60
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 47,
            column: 6
          },
          end: {
            line: 47,
            column: 60
          }
        }, {
          start: {
            line: 47,
            column: 6
          },
          end: {
            line: 47,
            column: 60
          }
        }],
        line: 47
      },
      "4": {
        loc: {
          start: {
            line: 48,
            column: 6
          },
          end: {
            line: 48,
            column: 52
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 48,
            column: 6
          },
          end: {
            line: 48,
            column: 52
          }
        }, {
          start: {
            line: 48,
            column: 6
          },
          end: {
            line: 48,
            column: 52
          }
        }],
        line: 48
      },
      "5": {
        loc: {
          start: {
            line: 57,
            column: 6
          },
          end: {
            line: 57,
            column: 31
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 57,
            column: 6
          },
          end: {
            line: 57,
            column: 31
          }
        }, {
          start: {
            line: 57,
            column: 6
          },
          end: {
            line: 57,
            column: 31
          }
        }],
        line: 57
      },
      "6": {
        loc: {
          start: {
            line: 60,
            column: 6
          },
          end: {
            line: 60,
            column: 52
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 60,
            column: 6
          },
          end: {
            line: 60,
            column: 52
          }
        }, {
          start: {
            line: 60,
            column: 6
          },
          end: {
            line: 60,
            column: 52
          }
        }],
        line: 60
      },
      "7": {
        loc: {
          start: {
            line: 60,
            column: 10
          },
          end: {
            line: 60,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 60,
            column: 10
          },
          end: {
            line: 60,
            column: 24
          }
        }, {
          start: {
            line: 60,
            column: 28
          },
          end: {
            line: 60,
            column: 44
          }
        }],
        line: 60
      },
      "8": {
        loc: {
          start: {
            line: 62,
            column: 6
          },
          end: {
            line: 63,
            column: 42
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 62,
            column: 6
          },
          end: {
            line: 63,
            column: 42
          }
        }, {
          start: {
            line: 62,
            column: 6
          },
          end: {
            line: 63,
            column: 42
          }
        }],
        line: 62
      },
      "9": {
        loc: {
          start: {
            line: 63,
            column: 11
          },
          end: {
            line: 63,
            column: 42
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 63,
            column: 11
          },
          end: {
            line: 63,
            column: 42
          }
        }, {
          start: {
            line: 63,
            column: 11
          },
          end: {
            line: 63,
            column: 42
          }
        }],
        line: 63
      },
      "10": {
        loc: {
          start: {
            line: 70,
            column: 6
          },
          end: {
            line: 70,
            column: 74
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 70,
            column: 6
          },
          end: {
            line: 70,
            column: 74
          }
        }, {
          start: {
            line: 70,
            column: 6
          },
          end: {
            line: 70,
            column: 74
          }
        }],
        line: 70
      },
      "11": {
        loc: {
          start: {
            line: 70,
            column: 10
          },
          end: {
            line: 70,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 70,
            column: 10
          },
          end: {
            line: 70,
            column: 37
          }
        }, {
          start: {
            line: 70,
            column: 41
          },
          end: {
            line: 70,
            column: 66
          }
        }],
        line: 70
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Table/fixedAuto.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { scrollClass } from '../Scroll/styles';
import { compareColumns } from '../utils/shallowEqual';
import { Component } from '../component';
export default (function (Table) {
  var _temp;

  cov_1z7nhipb2h.f[0]++;
  cov_1z7nhipb2h.s[0]++;
  return _temp =
  /*#__PURE__*/
  function (_Component) {
    _inherits(AutoFixed, _Component);

    var _super = _createSuper2(AutoFixed);

    function AutoFixed(props) {
      var _this;

      _classCallCheck(this, AutoFixed);

      cov_1z7nhipb2h.f[1]++;
      cov_1z7nhipb2h.s[1]++;
      _this = _super.call(this, props);
      _this.wrapper = void 0;
      cov_1z7nhipb2h.s[2]++;
      _this.state = {
        fixed: null
      };
      cov_1z7nhipb2h.s[3]++;
      _this.bindWrapper = _this.bindWrapper.bind(_assertThisInitialized(_this));
      cov_1z7nhipb2h.s[4]++;
      _this.resetAutoFixedState = _this.resetAutoFixedState.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(AutoFixed, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var _this2 = this;

        cov_1z7nhipb2h.f[2]++;
        var diff = (cov_1z7nhipb2h.s[5]++, ['fixed', 'width', 'height', 'data'].find(function (k) {
          cov_1z7nhipb2h.f[3]++;
          cov_1z7nhipb2h.s[6]++;
          return (cov_1z7nhipb2h.b[0][0]++, _this2.props[k]) && (cov_1z7nhipb2h.b[0][1]++, prevProps[k] !== _this2.props[k]);
        }));
        var reset = (cov_1z7nhipb2h.s[7]++, (cov_1z7nhipb2h.b[1][0]++, !compareColumns(prevProps.columns, this.props.columns)) || (cov_1z7nhipb2h.b[1][1]++, diff));
        cov_1z7nhipb2h.s[8]++;

        if (reset) {
          cov_1z7nhipb2h.b[2][0]++;
          cov_1z7nhipb2h.s[9]++;
          // eslint-disable-next-line react/no-did-update-set-state
          this.setState({
            fixed: null
          });
        } else {
          cov_1z7nhipb2h.b[2][1]++;
        }
      }
    }, {
      key: "getFixed",
      value: function getFixed() {
        cov_1z7nhipb2h.f[4]++;
        cov_1z7nhipb2h.s[10]++;

        if (this.state.fixed !== null) {
          cov_1z7nhipb2h.b[3][0]++;
          cov_1z7nhipb2h.s[11]++;
          return this.state.fixed;
        } else {
          cov_1z7nhipb2h.b[3][1]++;
        }

        cov_1z7nhipb2h.s[12]++;

        if (this.props.fixed === 'auto') {
          cov_1z7nhipb2h.b[4][0]++;
          cov_1z7nhipb2h.s[13]++;
          return 'both';
        } else {
          cov_1z7nhipb2h.b[4][1]++;
        }

        cov_1z7nhipb2h.s[14]++;
        return this.props.fixed;
      }
    }, {
      key: "bindWrapper",
      value: function bindWrapper(wrapper) {
        cov_1z7nhipb2h.f[5]++;
        cov_1z7nhipb2h.s[15]++;
        this.wrapper = wrapper;
      }
    }, {
      key: "resetFixed",
      value: function resetFixed() {
        cov_1z7nhipb2h.f[6]++;
        cov_1z7nhipb2h.s[16]++;

        if (!this.wrapper) {
          cov_1z7nhipb2h.b[5][0]++;
          cov_1z7nhipb2h.s[17]++;
          return;
        } else {
          cov_1z7nhipb2h.b[5][1]++;
        }

        var verticalHandle = (cov_1z7nhipb2h.s[18]++, this.wrapper.querySelector(".".concat(scrollClass('y'), ".").concat(scrollClass('show'))));
        var horizontalHandle = (cov_1z7nhipb2h.s[19]++, this.wrapper.querySelector(".".concat(scrollClass('x'), ".").concat(scrollClass('show'))));
        cov_1z7nhipb2h.s[20]++;

        if ((cov_1z7nhipb2h.b[7][0]++, verticalHandle) && (cov_1z7nhipb2h.b[7][1]++, horizontalHandle)) {
          cov_1z7nhipb2h.b[6][0]++;
          cov_1z7nhipb2h.s[21]++;
          return;
        } else {
          cov_1z7nhipb2h.b[6][1]++;
        }

        var fixed;
        cov_1z7nhipb2h.s[22]++;

        if (horizontalHandle) {
          cov_1z7nhipb2h.b[8][0]++;
          cov_1z7nhipb2h.s[23]++;
          fixed = 'x';
        } else {
          cov_1z7nhipb2h.b[8][1]++;
          cov_1z7nhipb2h.s[24]++;

          if (verticalHandle) {
            cov_1z7nhipb2h.b[9][0]++;
            cov_1z7nhipb2h.s[25]++;
            fixed = 'y';
          } else {
            cov_1z7nhipb2h.b[9][1]++;
          }
        }

        cov_1z7nhipb2h.s[26]++;
        this.setState({
          fixed: fixed
        });
      }
    }, {
      key: "fixedAuto",
      value: function fixedAuto() {
        cov_1z7nhipb2h.f[7]++;
        cov_1z7nhipb2h.s[27]++;

        if ((cov_1z7nhipb2h.b[11][0]++, this.props.fixed !== 'auto') || (cov_1z7nhipb2h.b[11][1]++, this.state.fixed !== null)) {
          cov_1z7nhipb2h.b[10][0]++;
          cov_1z7nhipb2h.s[28]++;
          return;
        } else {
          cov_1z7nhipb2h.b[10][1]++;
        }

        cov_1z7nhipb2h.s[29]++;
        this.resetFixed();
      }
    }, {
      key: "resetAutoFixedState",
      value: function resetAutoFixedState() {
        cov_1z7nhipb2h.f[8]++;
        cov_1z7nhipb2h.s[30]++;
        this.setState({
          fixed: null
        });
      }
    }, {
      key: "render",
      value: function render() {
        cov_1z7nhipb2h.f[9]++;
        var fixed = (cov_1z7nhipb2h.s[31]++, this.getFixed());
        cov_1z7nhipb2h.s[32]++;
        setTimeout(this.fixedAuto.bind(this));
        cov_1z7nhipb2h.s[33]++;
        return (
          /*#__PURE__*/
          React.createElement(Table, Object.assign({}, this.props, {
            fixed: fixed,
            bindWrapper: this.bindWrapper,
            resetFixAuto: this.resetAutoFixedState,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 82,
              columnNumber: 9
            }
          }))
        );
      }
    }]);

    return AutoFixed;
  }(Component), _temp;
});